import { Component, OnInit, ViewChild, Output, QueryList, ViewChildren, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { DatepickerComponent } from '../datepicker-component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DropdownComponent } from '../dropdown-component';
import { EventEmitter } from '@angular/core';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbdModalContent } from '../../alert-component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http'; 
import * as Parse from 'parse';
import met from 'src/app/model/metValues.json';

@Injectable()

@Component({
  selector: 'app-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.css']
})
export class ActivitylogComponent implements OnInit {
  activitylogForm : FormGroup;
  @Output() doneSubmiting = new EventEmitter();
  @ViewChild(DatepickerComponent) datepicker: DatepickerComponent;
  @ViewChildren(DropdownComponent) activitypickers: QueryList<DropdownComponent>;
  
  failedMessage : string;
  searchReturnedEmpty = false;
  showResults : boolean = false;
  resultsNames : string[] = [];
  sortedList = [];
  haveSelectedFood = false;
  selectedFoodIndex = 0;
  selectedFood = "";
  loggedFoodName = "";


  cookie : any;
  activityLogSaved : boolean;
  submitted = false;
  successMessage: string;
  activityFailed: boolean;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(
    private router : Router,
    private _bkoffService: BackOffServiceService,
    private modalService: NgbModal,
    private formBuilder : FormBuilder,
    private breakpointObserver: BreakpointObserver,
    private http: HttpClient
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
    this.getJSON().subscribe(data => {
      console.log(data);
  });
  }

  public getJSON(): Observable<any> {
    return this.http.get("./assets/json/metValues.json");
}

  ngOnInit(): void {
    let regexPatterns = {
      minutes: "^[0-9]+$",
   };
    this.activitylogForm  =  this.formBuilder.group({
      foodName: ['', []],
      minutes: ['', [Validators.required, Validators.pattern(regexPatterns.minutes)]],
      // activity: ['', [Validators.required]],
    });
  }
  get fmBuilder() { return this.activitylogForm.controls; }


  getFormControl(name:any) {
    return this.activitylogForm.get(name);
  }
  getFormValidationErrors() {
    var missingInput = false;
    Object.keys(this.activitylogForm.controls).forEach(key => {
    const controlErrors: ValidationErrors = this.activitylogForm.get(key).errors;
    if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {
            console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            if (keyError === "required"){
              missingInput = true;
            }
          });
        }
      });
      return missingInput;
    }

  closeActivityLog() {
    this.doneSubmiting.emit("saved");
    this.activityLogSaved = true;
  }
  

  searchClick() {
    this.resultsNames=[]
    var foodName = this.activitylogForm.get(['foodName']).value;
    // var foodName = "walking"
    this.sortedList = []
    var stringSimilarity = require('string-similarity');
    for (var i=0; i<met.activities.length; i++){
      // console.log(sortedList)
      var simularity = stringSimilarity.compareTwoStrings(met.activities[i].catagory, foodName) * 0.4;
      simularity += stringSimilarity.compareTwoStrings(met.activities[i].detail, foodName);
      if (met.activities[i].detail.includes(foodName)){simularity++}
      // console.log(simularity)
      var obj = {
        index: i,
        sim: simularity
      }
      if (this.sortedList.length<10){
        this.sortedList.push(obj)
        this.sortedList.sort((a,b) => (a.sim > b.sim) ? -1 : ((b.sim > a.sim) ? 1 : 0)); 
      }
      else{
        if (this.sortedList[this.sortedList.length-1].sim<simularity){
          this.sortedList.pop
          this.sortedList.push(obj)
          this.sortedList.sort((a,b) => (a.sim > b.sim) ? -1 : ((b.sim > a.sim) ? 1 : 0)); 
        }
      }
    }
    for (i=0; i<10; i++){
      let ind = this.sortedList[i].index
      var string = met.activities[ind].catagory
      string += ": "+met.activities[ind].detail
      this.resultsNames.push(string)
    }
    
    this.showResults = true
  }

  selectFood(food : string) {
    var index = this.resultsNames.indexOf(food);
    this.showResults = false;
    this.selectedFoodIndex = this.sortedList[index].index;
    this.selectedFood = food;
    this.haveSelectedFood = true;
    this.loggedFoodName = food;
  }

  submitClick(){
    // let dropdowns : DropdownComponent[] = this.activitypickers.toArray();
    this._bkoffService.getCurrentWeight().then((res) => {
      let weight = res;
      let MET = Number(met.activities[this.selectedFoodIndex].met);
    //MET values obtained from https://www.health.harvard.edu/staying-healthy/met-hour-equivalents-of-various-physical-activities
    //and https://golf.procon.org/view.resource.php?resourceID=004786

    if (this.activitylogForm.invalid) {
      const modalRef = this.modalService.open(NgbdModalContent);
      if (this.getFormValidationErrors()){
        modalRef.componentInstance.name = 'Please fill in all required fields';
      }
      else{
        modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      }
        return;
    }
    // let activity = dropdowns[0].selected;
    // let intensity = dropdowns[1].selected;

    // if (activity == ' ' || intensity == ' ') {
    //   const modalRef = this.modalService.open(NgbdModalContent);
    //   modalRef.componentInstance.name = 'You have left a question unanswered';
    //   return;
    // }
    
    var activityLogData = new LogsData();

    activityLogData.time = this.activitylogForm.get(['minutes']).value;
    activityLogData.activityDate = this.datepicker.dateEntry.toString();
    activityLogData.activity = this.selectedFood;
    activityLogData.intensity = "moderate";

    console.log("date " + this.datepicker.dateEntry.toString());

    //calculate calories burned

    

    let exerciseTime = parseInt(this.activitylogForm.get(['minutes']).value);
    //calories burned formula
    console.log(exerciseTime);
    console.log(MET);
    console.log("weight= " + weight);
    let calBurned = (exerciseTime*MET*weight*1.588)/200;
    activityLogData.activityCalories = Math.floor(calBurned);


    this._bkoffService.createActivityLog(activityLogData).then((success)=>{
      this.doneSubmiting.emit("saved")
      this.activityLogSaved = true;
      this.activitylogForm.reset();
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.name = 'You have logged '+ Math.floor(calBurned) + ' calories burned for this exercise';
      modalRef.componentInstance.title = 'Activity Log Stored';
    }).catch(()=>{
     this.failedMessage  = "Error saving activity logs "
     this.activityFailed = true
     this.sendUserFeedback(this.failedMessage)
     this.doneSubmiting.emit("failed")
     console.log(this.failedMessage)
    });
  });
  }

  sendUserFeedback(message:string){
    
    const modalRef = this.modalService.open(NgbdModalContent);
    if (!this.activityLogSaved){
      modalRef.componentInstance.name = 'Error saving data , please try again';
    }
   
  }

}